// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"b10183d2","604":"73bd1beb","738":"2a6fab3e","797":"2483b6da"}[chunkId] + ".chunk.js";
};